var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFooterBgImage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1360,
    height: 270,
    viewBox: "0 0 1360 270",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1164_8602)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1164_8602)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 58.5,
    cy: 96,
    rx: 130.5,
    ry: 128,
    fill: "#030303"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_1164_8602)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1192.5,
    cy: 66,
    rx: 130.5,
    ry: 128,
    fill: "#030303"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.3,
    filter: "url(#filter2_d_1164_8602)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "path-4-inside-1_1164_8602",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M680.5 14.5352C833.207 14.5352 957 136.061 957 285.971C957 291.509 956.83 297.009 956.497 302.465H404.504C404.171 297.009 404 291.509 404 285.971C404 136.061 527.793 14.5353 680.5 14.5352Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M680.5 14.5352C833.207 14.5352 957 136.061 957 285.971C957 291.509 956.83 297.009 956.497 302.465H404.504C404.171 297.009 404 291.509 404 285.971C404 136.061 527.793 14.5353 680.5 14.5352Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.5 14.5352C833.207 14.5352 957 136.061 957 285.971C957 291.509 956.83 297.009 956.497 302.465H404.504C404.171 297.009 404 291.509 404 285.971C404 136.061 527.793 14.5353 680.5 14.5352Z",
    fill: "url(#paint0_linear_1164_8602)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M680.5 14.5352V12.5352V14.5352ZM957 285.971H959H957ZM956.497 302.465V304.465H958.379L958.493 302.587L956.497 302.465ZM404.504 302.465L402.508 302.587L402.622 304.465H404.504V302.465ZM404 285.971H402H404ZM680.5 14.5352V16.5352C832.137 16.5352 955 137.2 955 285.971H957H959C959 134.922 834.276 12.5352 680.5 12.5352V14.5352ZM957 285.971H955C955 291.468 954.831 296.927 954.501 302.343L956.497 302.465L958.493 302.587C958.829 297.09 959 291.55 959 285.971H957ZM956.497 302.465V300.465H404.504V302.465V304.465H956.497V302.465ZM404.504 302.465L406.5 302.343C406.169 296.927 406 291.468 406 285.971H404H402C402 291.55 402.172 297.09 402.508 302.587L404.504 302.465ZM404 285.971H406C406 137.2 528.863 16.5353 680.5 16.5352V14.5352V12.5352C526.724 12.5353 402 134.922 402 285.971H404Z",
    fill: "url(#paint1_linear_1164_8602)",
    mask: "url(#path-4-inside-1_1164_8602)"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_1164_8602)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.5,
    cy: 246,
    rx: 53.5,
    ry: 52,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 194.5C51.7846 194.5 75.5 217.571 75.5 246C75.5 274.429 51.7846 297.5 22.5 297.5C-6.78459 297.5 -30.5 274.429 -30.5 246C-30.5 217.571 -6.78459 194.5 22.5 194.5Z",
    stroke: "#FF7A00"
  })), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter4_d_1164_8602)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 1323.5,
    cy: 124,
    rx: 53.5,
    ry: 52,
    fill: "#030303"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1323.5 72.5C1352.78 72.5 1376.5 95.5706 1376.5 124C1376.5 152.429 1352.78 175.5 1323.5 175.5C1294.22 175.5 1270.5 152.429 1270.5 124C1270.5 95.5706 1294.22 72.5 1323.5 72.5Z",
    stroke: "#FF7A00"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1164_8602",
    x: -80,
    y: -40,
    width: 277,
    height: 272,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.52549 0 0 0 0 0.231373 0 0 0 0 0.0235294 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1164_8602"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1164_8602",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_1164_8602",
    x: 1054,
    y: -70,
    width: 277,
    height: 272,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.52549 0 0 0 0 0.231373 0 0 0 0 0.0235294 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1164_8602"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1164_8602",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_1164_8602",
    x: 311.7,
    y: -90.7648,
    width: 737.6,
    height: 472.53,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 16,
    operator: "dilate",
    in: "SourceAlpha",
    result: "effect1_dropShadow_1164_8602"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -13
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 38.15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.418269 0 0 0 0 0.151623 0 0 0 0 0.00804364 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1164_8602"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1164_8602",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_1164_8602",
    x: -39,
    y: 186,
    width: 123,
    height: 120,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.52549 0 0 0 0 0.231373 0 0 0 0 0.0235294 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1164_8602"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1164_8602",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_d_1164_8602",
    x: 1262,
    y: 64,
    width: 123,
    height: 120,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.52549 0 0 0 0 0.231373 0 0 0 0 0.0235294 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1164_8602"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1164_8602",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1164_8602",
    x1: 404,
    y1: 14.5352,
    x2: 639.885,
    y2: 467.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FEFEFE",
    stopOpacity: 0.06
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FEFEFE",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1164_8602",
    x1: 404,
    y1: 14.5352,
    x2: 639.885,
    y2: 467.577,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF7A00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4B4B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1164_8602"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 16C0 7.16344 7.16344 0 16 0H1344C1352.84 0 1360 7.16344 1360 16V270H0V16Z",
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterBgImage);
export default __webpack_public_path__ + "static/media/footer-bg-image.97b35b5d5e3950dc155b1246e5fc109d.svg";
export { ForwardRef as ReactComponent };